exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message--canceled {\n  opacity: 0.7; }\n\n.message--title {\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0; }\n\n.message--body {\n  font-size: 13px;\n  margin: 0; }\n\n.icons__action {\n  padding: 0px !important; }\n\n.icons__action button {\n    margin: 0;\n    width: 27px;\n    text-align: center; }\n\n.icons__action i {\n    text-align: center; }\n\n.th--small {\n  width: 15em; }\n\n.th--edit {\n  width: 60px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/messages/messages.component.scss
// module id = ../../../../../src/app/pages/messages/messages.component.scss
// module chunks = main